"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectProfileReferenceSchema = void 0;
exports.ProjectProfileReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/project-profiles.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ProjectProfileReference",
    "description": "Ongoing content projects without a specific location / start and end-date. (e.g. kaleidoscope)",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:project-profiles"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC1wcm9maWxlcy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvY29udGVudC9wcm9qZWN0LXByb2ZpbGVzLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDZCQUE2QixHQUFHO0lBQzNDLEtBQUssRUFBRSxnRkFBZ0Y7SUFDdkYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUseUJBQXlCO0lBQ2xDLGFBQWEsRUFBRSxnR0FBZ0c7SUFDL0csTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTiw2QkFBNkI7YUFDOUI7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSw2RUFBNkU7U0FDekY7S0FDRjtDQUNGLENBQUEifQ==